export default {
    //关于华翔
    companyProfile: {
        title: 'Unternehmensübersicht',
    },
      //廉洁合规
  integrity: {
    p1: {
      title: "Integrität und Compliance-Verpflichtung",
      c1:
        "Wir sind fest davon überzeugt, dass Integrität der Eckpfeiler der Leistung ist, die es uns ermöglicht, qualitativ hochwertige Produkte und Dienstleistungen anzubieten, ehrliche Beziehungen zu Kunden und Lieferanten aufzubauen und weiterhin im Wettbewerb zu gewinnen. Jedes Mitglied von Ningbo Huaxiang hat die Verantwortung, unseren Verhaltenskodex einzuhalten：",
      l1: [
        "Einhaltung aller anwendbaren Gesetze und Vorschriften, die die globalen Geschäftsaktivitäten unseres Unternehmens leiten; Seien Sie ehrlich, fair und zuverlässig im Umgang mit allen Geschäftsaktivitäten und Geschäftsbeziehungen von NBHX;",
        "ermeidung von Konflikten öffentlicher und privater Interessen;",
        "Förderung einer Atmosphäre der Chancengleichheit für alle innerhalb des Unternehmens;",
        "Verpflichtung zur Gewährleistung der Arbeitssicherheit und zum Schutz der Umwelt;",
        "Aufbau und Pflege einer Unternehmenskultur, in der Menschen Integrität erkennen, respektieren und praktizieren.",
      ],
      c2:
        "NBHX hat den Verhaltenskodex, die Ethik und das Betrugsbekämpfungssystem formuliert und herausgegeben, um sicherzustellen, dass jedes Mitglied die Berufsethik bei Geschäftstätigkeiten einhalten sollte:",
      l2: [
        "Vermeidung unsachgemäßer Zahlungen;",
        "Gesetze im Zusammenhang mit internationalem Handel und internationalen Finanztransaktionen zu verstehen und einzuhalten;",
        "Verhütung der Geldwäsche;",
        "Achtung der Privatsphäre;",
        "Entwicklung der Beziehungen zu Lieferanten legal, fair und effektiv;",
        "Handel mit allen Regierungsvertretern in Übereinstimmung mit den höchsten ethischen Standards;",
        "Einhaltung des Wettbewerbsrechts;",
        "Vermeidung von Interessenkonflikten;",
        "Andere Ethikkodexes, die im Verhaltens- und Ethikkodex festgelegt sind.",
      ],
    },
    p2: {
      title: "Inhalt der Annahme des Berichts",
      c1:
        "NBHX akzeptiert Berichte über Betrugsbekämpfung und Interessenkonflikte innerhalb und außerhalb des Unternehmens, einschließlich der folgenden Arten:",
      t1: "1. Betrug",
      l1: [
        "1.1 Annahme oder Zahlung von Bestechungsgeldern und Kickbacks；",
        "1.2 Nutzen Sie Unternehmensressourcen und Positionseinfluss, um persönliche Interessen zu suchen；",
        "1.3 Übertragung von Transaktionen, die das Unternehmen unter normalen Umständen rentabel machen können, auf andere Einheiten für eigene Interessen;",
        "1.4 Illegale Nutzung des Vermögens des Unternehmens, Unterschlagung, Veruntreuung, missbräuchliche Aneignung und Diebstahl des Vermögens des Unternehmens;",
        "1.5 Durchführung von Geschäftstätigkeiten mit anderen Einheiten im Namen des Unternehmens ohne Genehmigung, die dazu führen, dass das Unternehmen Geld zahlt oder Schulden für falsche Transaktionen trägt;",
        "1.6 absichtliche Verschleierung oder Falschdarstellung von Transaktionen;",
        "1.7 Fälschung oder Änderung von Buchführungsunterlagen oder Gutscheinen sowie Anfertigung falscher Aufzeichnungen, irreführender Aussagen oder größerer Auslassungen in Finanz- und Rechnungslegungsberichten und Offenlegung von Informationen;",
        "1.8 Steuerhinterziehung;",
        "1.9 Offenlegung von Geschäftsgeheimnissen oder technischen Geheimnissen des Unternehmens;",
        "1.10 Beteiligung an illegalen Wirtschaftstätigkeiten;",
        "1.11 Direktoren, Vorgesetzte, Geschäftsführer und andere Führungskräfte vernachlässigen ihre Pflichten und missbrauchen ihre Befugnisse。",
      ],
      t2: "2. Folgende Interessenkonflikte von Führungskräften oder Mitarbeitern (und deren nahen Verwandten)",
      l2: [
        "2.1 direkt oder indirekt die Unternehmen oder wettbewerbsfähigen Unternehmen kontrollieren, die mit NBHX handeln;",
        "2.2 Vertreter des Handelsunternehmens ist oder an der Transaktion beteiligt ist;",
        "2.3 Waren, Bargeld oder Wertpapiere, deren Wert den allgemeinen Geschenkwert von Handelsunternehmen oder wettbewerbsfähigen Unternehmen übersteigt, als Geschenke annehmen oder Darlehen und üppige Gastfreundschaft annehmen;",
        "2.4 Bereitstellung bedeutender Management-, Beratungs- und anderer Dienstleistungen (einschließlich der Tätigkeit als Direktor) für ein anderes Unternehmen ohne die Zustimmung des Unternehmens;",
        "2.5 Auswirkungen auf die Transaktionen zwischen Handelsunternehmen oder wettbewerbsfähigen Unternehmen und Dritten (z. B. zwingen Sie die Lieferanten von NBHX, von einem Unternehmen im Besitz einer natürlichen Person zu kaufen);",
        "2.6 Tritt mit NBHX an。",
      ],
    },
    p3: {
      title: "Berichterstattungskanäle",
      c1:
        "NBHX Berichtskanal und öffnen Sie den Berichtskanal für die ganze Gesellschaft und erhalten Sie die Berichtsinformationen über Betrugsbekämpfung und Interessenkonflikt von innen und außerhalb des Unternehmens。\n\n",
      l1: [
        "Telefon melden：138 1803 7523",
        "Postfach melden：audit@nbhx.com",
        "Postanschrift：Interne Revisionsabteilung von Ningbo Huaxiang Electronics Co., Ltd., Oriental Financial Plaza, 1168 Century Avenue, Pudong New Area, Shanghai",
      ],
      c2:'Tipps für die Berichterstattung',
      l2:[
          'Informanten können wählen, ob sie im richtigen Namen oder anonym berichten. Wir werden die Identitätsinformationen des Informanten streng vertraulich behandeln und keine Vergeltungsmaßnahmen gegen den Informanten zulassen.',
          'Die vom Informanten übermittelten Informationen müssen so detailliert und spezifisch wie möglich sein und können materielle Beweise liefern oder eine klare Richtung der Untersuchung aufzeigen.',
          'Der Informant ist für die Echtheit der gemeldeten Inhalte verantwortlich. Nach Überprüfung behält sich Huaxiang das Recht vor, rechtliche Maßnahmen oder interne Bestrafungen gegen den Informanten für die Fälschung von Tatsachen und absichtliche Verleumdung zu ergreifen.'
        ]
    },
  },

    //全球布局
    中国: 'Chinesisches',
    全球: 'Globales',
    全球布局: "Globales Netzwerk",
    中国布局: "Chinesisches Netzwerk",
    desclist: [[{
        num: 0,
        unit: 'Mrd €',
        title: 'Umsatz in 2018',
        picture: require('../../assets/img/about/1.png')
    }, {
        num: 0,
        unit: '',
        title: 'Fertigungsstandort',
        picture: require('../../assets/img/about/2.png')
    }, {
        num: 0,
        unit: '',
        title: 'Mitarbeiterzahl',
        picture: require('../../assets/img/about/3.png')
    }, {
        num: 0,
        unit: '',
        title: '<div>Regionale F&E Center</div><small>China | USA | Deutschlang</small>',
        picture: require('../../assets/img/about/4.png')
    }], [{
        num: 0,
        unit: 'Mrd €',
        title: 'Umsatz in 2018',
        picture: require('../../assets/img/about/1.png')
    }, {
        num: 0,
        unit: '',
        title: 'Fertigungsstandort',
        picture: require('../../assets/img/about/2.png')
    }, {
        num: 0,
        unit: '',
        title: 'Mitarbeiterzahl',
        picture: require('../../assets/img/about/3.png')
    }, {
        num: 0,
        unit: '',
        title: '<div>Regionale F&E Center</div>',
        picture: require('../../assets/img/about/4.png')
    }]
    ],
    enterpriselist: [{
        title: 'Asien',
        list: ['China (über 50 Fertigungsstandorte & 1 regionales F&E Center)', 'Philippines Schlemmer Automotive Parts Co., Ltd.', 'Indonesia Schlemmer Automotive Parts Co., Ltd.', 'Vietnam Schlemmer Automotive Parts Co., Ltd.', 'Singapore Schlemmer Automotive Parts Co., Ltd.']
    }, {
        title: 'Europa',
        list: ['NBHX TRIM GmbH', 'HIB TRIM Part Solutions GmbH', 'NBHX Trim Management Services GmbH', 'Northern Automotive Systems Limited', 'NBHX TRIM CZ s.r.o', 'SC Rolem SRL.RO']
    }, {
        title: 'Nord Amerika',
        list: ['NBHX TRIM USA Corporation', 'Northern Engraving Corporation ', 'NBHX TRIM Mexico Sde R.L de C.V.MEX'],
    }
    ],
    markerTitles: [{
        x: '887',
        y: '397',
        title: 'Chengdu Huaxiang Automotive Roof System Co., Ltd.\nChengdu INOAC Huaxiang Automotive Parts Co., Ltd.\nChengdu Huaxiang Car Silencer Co., Ltd.'
    }, {
        x: '903',
        y: '403',
        title: 'Mianyang Schlemmer Automotive Parts Co., Ltd.'
    }, {
        x: '971',
        y: '383',
        title: 'Chongqing SMR Huaxiang Automotive Parts Co., Ltd.'
    }, {
        x: '1058',
        y: '256',
        title: 'Liuzhou INOAC Huaxiang Automotive Parts Co., Ltd.'
    }, {
        x: '1102',
        y: '355',
        title: 'Changsha INOAC Huaxiang Automotive Parts Co., Ltd.'
    }, {
        x: '1150',
        y: '414',
        title: 'Wuhan INOAC Huaxiang Automotive Parts  Co., Ltd.\nWuhan Schlemmer Automotive Parts Co., Ltd.',
    }, {
        x: '1150',
        y: '231',
        title: 'Foshan Huaxiang Auto Headliner System Co.,Ltd.\nFoshan INOAC Huaxiang Automotive Parts Co., Ltd.\nFoshan Huaxiang Automotive Metal Parts Co., Ltd.'
    }, {
        x: '1163',
        y: '595',
        title: 'Tianjin Huaxiang Auto Headliner System Co.,Ltd.\nTianjin INOAC Huaxiang Automotive Parts Co., Ltd.\nTianjin Schlemmer Automotive Parts Co., Ltd.\nTianjin Huaxiang Automotive Metal Parts Co., Ltd.\nTianjin SMR Huaxiang Automotive Parts Co., Ltd.'
    }, {
        x: '1176',
        y: '364',
        title: 'Nanchang Huaxiang Automotive Parts Co., Ltd.\nNanchang Huaxiang Automotive Interior and Exterior Co., Ltd.'
    }, {
        x: '1176',
        y: '249',
        title: 'Dongguan Huaxiang Automotive Door System Co., Ltd.\nDongguan INOAC KENJOU Automotive Parts Co., Ltd.'
    }, {
        x: '1160',
        y: '209',
        title: 'Zhongshan Schlemmer Automotive Parts Co., Ltd.'
    }, {
        x: '1217',
        y: '559',
        title: 'Yantai Schlemmer Automotive Parts Co., Ltd.\nYantai Aibeisi INOAC Huaxiang Automotive Parts Co., Ltd.'
    }, {
        x: '1236',
        y: '541',
        title: 'Qingdao Huaxiang Automotive Roof System Co., Ltd.\nQingdao Huaxiang Automotive Metal Parts Co., Ltd.'
    }, {
        x: '1242',
        y: '452',
        title: 'Yangzhou Huaxiang Automotive Door System Co., Ltd.'
    }, {
        x: '1258',
        y: '448',
        title: 'Wuxi INOAC Huaguang Automotive Parts Co., Ltd.'
    }, {
        x: '1242',
        y: '626',
        title: 'Shenyang Huaxiang Automotive Parts Co., Ltd.\nShenyang Aibisi INOAC Huaxiang Automotive Parts Co., Ltd.'
    }, {
        x: '1270',
        y: '440',
        title: 'Suzhou Schlemmer Automotive Parts Co., Ltd.'
    }, {
        x: '1262',
        y: '679',
        title: 'Gongzhuling INOAC Huaxiang Automotive Parts Co., Ltd.\nGongzhuling Huaxiang Auto Headliner System Co.,Ltd.'
    }, {
        x: '1295',
        y: '441',
        title: 'Shanghai Zhixuan Automotive Accessories Co., Ltd.\nShanghai INOAC Huaxiang Automotive Parts Co., Ltd.'
    }, {
        x: '1301',
        y: '403',
        title: 'NBHX Automotive Door System Co., Ltd.\nNingbo INOAC Huaxiang Automotive Parts Co., Ltd.\nNBHX Helbako Automotive Electronics Co., Ltd.\nNingbo Schlemmer Automotive Parts Co., Ltd.\nNBHX Trim Automotive Accessories Co., Ltd.\nNingbo SMR Automotive Parts Co., Ltd.\nNingbo Aibeisi INOAC Automotive Parts Co., Ltd.\nNBHX Automotive Accessories Co., Ltd.\nNingbo Mile Mould Manufacturing Co., Ltd.\nNBHX Natural Fiber Technology Co., Ltd.\nNingbo Lawrence Automotive Interior Co., Ltd.\nNBHX Automotive Surface Treatment Technology Co., Ltd.\nNBHX Automotive New Material Technology Co., Ltd.'
    }, {
        x: '1288',
        y: '689',
        title: 'Changchun Schlemmer Automotive Parts Co., Ltd.\nChangchun Huaxiang Car Silencer Co.,Ltd.'
    }, {
        x: '1100',
        y: '475',
        title: 'Zhengzhou INOAC Huaxiang Automotive Parts Co., Ltd.'
    }],
    markerTitle: ['Northern Automotive Systems Limited', 'NBHX TRIM GmbH\nHIB TRIM Part Solutions GmbH\nNBHX Trim Management Services GmbH', 'NBHX TRIM CZ s.r.o', 'SC Rolem SRL.RO', 'Vietnam Schlemmer Automotive Parts Co. Ltd.', 'Schlemmer (S.E.A.) Pte. Ltd. ', 'PT Schlemmer Automotive Indonesia', 'Schlemmer Philippines Inc.', 'NBHX TRIM Mexico Sde R.L de C.V.MEX', 'Northern Engraving Corporation ', 'NBHX TRIM USA Corporation', 'China (über 50 Fertigungsstandorte & 1 regionales F&E Center)'],
    enterpriseChinaList: [{
        title: 'Ost China',
        list: ['NBHX Automotive Door System Co., Ltd.', 'Ningbo INOAC Huaxiang Automotive Parts Co., Ltd.', 'NBHX Helbako Automotive Electronics Co., Ltd.', 'Ningbo Schlemmer Automotive Parts Co., Ltd.', 'NBHX Trim Automotive Accessories Co., Ltd.', 'Ningbo SMR Automotive Parts Co., Ltd.', 'Ningbo Aibeisi INOAC Automotive Parts Co., Ltd.', 'NBHX Automotive Accessories Co., Ltd.', 'Ningbo Mile Mould Manufacturing Co., Ltd.', 'NBHX Natural Fiber Technology Co., Ltd.', 'Ningbo Lawrence Automotive Interior Co., Ltd.', 'NBHX Automotive Surface Treatment Technology Co., Ltd.', 'NBHX Automotive New Material Technology Co., Ltd.', 'Shanghai Zhixuan Automotive Accessories Co., Ltd.', 'Shanghai INOAC Huaxiang Automotive Parts Co., Ltd.', 'Qingdao Huaxiang Automotive Roof System Co., Ltd.', 'Qingdao Huaxiang Automotive Metal Parts Co., Ltd.', 'Yangzhou Huaxiang Automotive Door System Co., Ltd.', 'Suzhou Schlemmer Automotive Parts Co., Ltd.', 'Wuxi INOAC Huaguang Automotive Parts Co., Ltd.', 'Yantai Schlemmer Automotive Parts Co., Ltd.', 'Yantai Aibeisi INOAC Huaxiang Automotive Parts Co., Ltd.']
    }, {
        title: 'Zentral China',
        list: ['Wuhan INOAC Huaxiang Automotive Parts  Co., Ltd.', 'Wuhan Schlemmer Automotive Parts Co., Ltd.', 'Changsha INOAC Huaxiang Automotive Parts Co., Ltd.', 'Zhengzhou INOAC Huaxiang Automotive Parts Co., Ltd.', 'Nanchang Huaxiang Automotive Parts Co., Ltd.', 'Nanchang Huaxiang Automotive Interior and Exterior Co., Ltd.']
    }, {
        title: 'Süd China',
        list: ['Dongguan Huaxiang Automotive Door System Co., Ltd.', 'Dongguan INOAC KENJOU Automotive Parts Co., Ltd.', 'Foshan Huaxiang Auto Headliner System Co.,Ltd.', 'Foshan INOAC Huaxiang Automotive Parts Co., Ltd.', 'Foshan Huaxiang Automotive Metal Parts Co., Ltd.', 'Zhongshan Schlemmer Automotive Parts Co., Ltd.', 'Liuzhou INOAC Huaxiang Automotive Parts Co., Ltd.']
    }, {
        title: 'Nord China',
        list: ['Tianjin Huaxiang Auto Headliner System Co.,Ltd.', 'Tianjin INOAC Huaxiang Automotive Parts Co., Ltd.', 'Tianjin Schlemmer Automotive Parts Co., Ltd.', 'Tianjin Huaxiang Automotive Metal Parts Co., Ltd.', 'Tianjin SMR Huaxiang Automotive Parts Co., Ltd.']
    }, {
        title: 'Nordost China',
        list: ['Changchun Schlemmer Automotive Parts Co., Ltd.', 'Changchun Huaxiang Car Silencer Co.,Ltd.', 'Gongzhuling INOAC Huaxiang Automotive Parts Co., Ltd.', 'Gongzhuling Huaxiang Auto Headliner System Co.,Ltd.', 'Shenyang Huaxiang Automotive Parts Co., Ltd.', 'Shenyang Aibisi INOAC Huaxiang Automotive Parts Co., Ltd.']
    }, {
        title: 'Südwest China',
        list: ['Chengdu Huaxiang Automotive Roof System Co., Ltd.', 'Chengdu INOAC Huaxiang Automotive Parts Co., Ltd.', 'Chengdu Huaxiang Car Silencer Co., Ltd.', 'Mianyang Schlemmer Automotive Parts Co., Ltd.', 'Chongqing SMR Huaxiang Automotive Parts Co., Ltd.']
    }],
    //合作伙伴
    partnershipList: [{
        name: 'Jiangling Motors Group Co., Ltd.',
        desc: 'Jiangling Motor Group Co., Ltd. ist einer der wichtigsten Fahrzeug-Exporteure in China, insbesondere für Nutzfahrzeuge. Das Unternehmen verfügt über 6 Gesamtfahrzeug-Fertigungsstätten, die mehrere Varianten abdecken und die sechs wichtigesten Unterbaugruppen für Automobile herstellen sowie über eigene Kapazitäten für Forschung und Entwicklung verfügen.',
        logo: require('../../assets/img/about/partnership/1.jpg'),
        url: 'https://www.jmcg.com.cn/'
    }, {
        name: 'FAWER Automotive Parts Co., Ltd.',
        desc: 'FAWER Automotive Parts Co., Ltd. ist auf die Produktion von Automobilsystemen für Umweltkontrolle, Fahrwerk, Lenkung und Getriebe, Sicherheit und Motorenzubehör spezialisiert. Das Unternehmen liefert hauptsächlich Teile an FAW Group, SWV, SGM und Dongfeng PSA. Außerdem werden die Produkte in mehr als 10 Überseemärkten wie über USA, Frankreich, Italien, Korea, Japan und Mittlerer Osten vertrieben.',
        logo: require('../../assets/img/about/partnership/2.jpg'),
        url: 'http://www.fawer.com.cn/zh-cn/'
    }, {
        name: 'Changchun Fawsn Group Co., Ltd.',
        desc: 'Changchun Fawsn Group Co., Ltd. beschäftigt sich mit Forschung & Entwicklung, Herstellung und Just-in-Time-Lieferung von kundenspezifischen Modulen für Brems- und Lenksysteme, Elektronik und Elektrik, Innen- und Außenverkleidungsmodulen sowie Motorzubehör. Das Unternehmen liefert hauptsächlich Produkte für Marken unter dem Anteilseigner, der FAW-Gruppe und hat Joint Ventures mit vielen namhaften Automobilunternehmen auf der ganzen Welt gegründet.',
        logo: require('../../assets/img/about/partnership/3.jpg'),
        url: 'http://www.fawsn.com.cn/'
    }, {
        name: 'Samvardhana Motherson Reflectec (SMR)',
        desc: 'Samvardhana Motherson Reflectec ist ein weltweit führender Hersteller von Rückspiegeln für PKW und Pionier bei der Entwicklung von intelligenten Automobilkameras. Inzwischen ist SMR auch Mitglied des weltbekannten Automobilzulieferers Samvardhana Motherson Group (SMG).',
        logo: require('../../assets/img/about/partnership/4.jpg'),
        url: 'http://www.smr-automotive.com/en'
    }, {
        name: 'Schlemmer Holding GmbH',
        desc: 'Die Schlemmer Holding GmbH konzentriert sich auf die Entwicklung und Produktion von hochspezialisierten Kunststoff- und Metallteilen. Aufgrund seiner 60-jährigen Erfahrung gehört das Unternehmen zu den weltweit führenden Anbietern von Kabelbaumschutzlösungen.',
        logo: require('../../assets/img/about/partnership/5.jpg'),
        url: 'http://www.schlemmer.com.cn/'
    }, {
        name: 'INOAC CORPORATION',
        desc: 'Die INOAC Corporation wurde 1926 gegründet. Ihre Produktlinie umfasst Kfz-Innen- und Außenteile sowie Komponenten aus PU, Gummi und Verbundwerkstoffen. Die Produktlinie umfasst auch mehrere Materialien für diese Automobilkomponenten, Industrieanwendungen, Kosmetikbehälter und Gebäude.',
        logo: require('../../assets/img/about/partnership/6.jpg'),
        url: 'https://www.inoac.co.jp/'
    }, {
        name: 'FAURECIA',
        desc: 'FAURECIA ist ein international tätiger  Automobilzulieferer, der qualitativ hochwertige innovative Produkte, technische Lösungen und Dienstleistungen bietet. Das Unternehmen gehört zum PSA-Konzern und ist weltweit führend in den Bereichen Autositze, umweltfreundliche mobile Systeme und Fahrzeuginnenausstattung.',
        logo: require('../../assets/img/about/partnership/7.jpg'),
        url: 'https://www.faurecia.cn/'
    }, {
        name: 'Ningbo Fulda Intelligent Technology Co., Ltd. ',
        desc: 'Ningbo Fulda Intelligent Technology Co., Ltd. is committed to the simultaneous design, development, and production of intelligent electronic integrated control systems, lighting systems, functional parts, and key systems. Its main clients include FAW Volkswagen, SAIC Volkswagen, SAIC-GM, Beijing Benz, and other OEMs. The company has strong research and development capabilities, and holds a number of national patents.',
        logo: require('../../assets/img/about/partnership/8.jpg'),
        url: 'http://www.fuerda-china.com/'
    }, {
        name: 'Helbako GmbH',
        desc: 'Helbako ist ein 1977 gegründeter globaler Automobilzulieferer mit Hauptsitz in Deutschland. Das Unternehmen befasst sich hauptsächlich mit der Forschung und Entwicklung sowie der Herstellung von Elektronikprodukten für Autos. Die Produkte umfassen elektronische Steuergeräte für Kraftstoffpumpen, Leuchtweitenregulierungssysteme, Dachsteuersysteme usw. BMW, Mercedes-Benz, Volkswagen, Audi und Porsche sind Hauptkunden von Helbako.',
        logo: require('../../assets/img/about/partnership/9.jpg'),
        url: 'https://www.helbako.de/startseite/'
    }, {
        name: 'CIMC Vehicles (Group) Co., Ltd.',
        desc: 'CIMC Vehicles (Group) Co., Ltd. ist eine Tochtergesellschaft der China International Marine Containers (Group) Co., Ltd. und eine der größten privaten Automobilunternehmensgruppen in China. Es werden hauptsächlich Sattelauflieger und Sonderfahrzeuge hergestellt und vertrieben.',
        logo: require('../../assets/img/about/partnership/10.jpg'),
        url: 'http://www.cimcvehiclesgroup.com/'
    }, {
        name: 'ABC Technologies',
        desc: 'ABC Technologies ist ein weltberühmter Hersteller von Automobilsystemen und -komponenten, der seit 1974 in Kanada ansässig ist. Dank Hunderten von Patenten zu Werkstofftechnologien, Produkten und Fertigungssystemen ist die Innovationskraft von ABC Technologies international bekannt.',
        logo: require('../../assets/img/about/partnership/11.jpg'),
        url: 'http://www.abcgroupinc.com'
    }, {
        name: 'Wuxi Huaguang Auto Parts Group Co., Ltd.',
        desc: 'Wuxi Huaguang Auto Parts Group Co., Ltd. wurde 1990 gegründet und stellt gewalzte und gestanzte Produkte, Baugruppen, Spritzgussprodukte und extrudierte Produkte her, die hauptsächlich an FAW-Volkswagen, SAIC-Volkswagen, Shenlong und viele andere OEMs geliefert werden.',
        logo: require('../../assets/img/about/partnership/12.jpg'),
        url: 'http://www.huaguang-group.com/'
    }],
    //客户
    navlist: ['Kunden außerhalb Chinas', 'Joint Venture OEMs', 'Lokale, chinesische Kunden', 'Neue Industriezweige'],
    //荣誉
    awardList: [
        [{
            poster: require('../../assets/img/about/award/2019-1.jpg'),
            year: 'Jahr 2019',
            title: 'NBHX Electronics Co., Ltd.: ',
            content: '"Excellent Enterprise of Automotive Parts Supply Chain 2019 Award" von der Chinesische Föderation für Logistik und Einkauf (CFLP)'
        }], [{
            poster: require('../../assets/img/about/award/b-1.jpg'),
            year: 'Jahr 2018',
            title: 'NBHX Trim Automotive ',
            content: 'Accessories Co., Ltd: "Excellent Developer & Supplier Award 2018" von FAW-VW '

        }, {
            poster: require('../../assets/img/about/award/b-2.jpg'),
            year: 'Jahr 2018',
            title: 'National High-Tech Enterprise Award',
            content: 'Nanchang Huaxiang Automotive Parts Co., Ltd.: "National High-Tech Enterprise Award" '

        }, {
            poster: require('../../assets/img/about/award/b-5.jpg'),
            year: 'Jahr 2018',
            title: 'Q1 Award',
            content: 'Chongqing SMR Huaxiang Automotive Parts Co., Ltd.: "Q1 Award" von Changan Ford Automobile Co., Ltd.'

        }, {
            poster: require('../../assets/img/about/award/b-3.jpg'),
            year: 'Jahr 2018',
            title: 'Q1 Award',
            content: 'Ningbo SMR Huaxiang Automotive Mirrors Co., Ltd.: "Q1 Award" von Changan Ford Automobile Co., Ltd.'

        }, {
            poster: require('../../assets/img/about/award/b-4.jpg'),
            year: 'Jahr 2018',
            title: 'JLRQ Excellent Supplier Award',
            content: 'Ningbo SMR Huaxiang Automotive Mirrors Co., Ltd.: "JLRQ Excellent Supplier Award" von Jaguar Land Rover Automotive PLC'
        }, {
            poster: require('../../assets/img/about/award/b-6.jpg'),
            year: 'Jahr 2018',
            title: 'Excellent Supplier Award',
            content: 'Ningbo INOAC Huaxiang Automotive Parts Co., Ltd.: "Excellent Supplier" von Brilliance Auto Group'

        }, {
            poster: require('../../assets/img/about/award/b-7.jpg'),
            year: 'Jahr 2018',
            title: 'General Manager Excellence Award',
            content: 'Ningbo Schlemmer Automotive Parts Co., Ltd.: "General Manager Quality Excellence" von CNHTC'

        }, {
            poster: require('../../assets/img/about/award/b-8.jpg'),
            year: 'Jahr 2018',
            title: 'Zhejiang Famous Brand Product Certification',
            content: 'NBHX Electronic Co., Ltd. "Zhejiang Famous Brand Product " vom Büro für Qualität&Technologie der  Zhejiang Provinz'

        }], [{
            poster: require('../../assets/img/about/award/a-1.jpg'),
            year: 'Jahr 2017',
            title: '20-Year Zhihe Jinshi Award',
            content: 'Changchun Huaxiang Car Silencer Co.,Ltd. "20-Year Zhihe Jinshi Award" von FAW Car Co., Ltd.'

        }, {
            poster: require('../../assets/img/about/award/a-2.jpg'),
            year: 'Jahr 2017',
            title: 'Special Contribution Award',
            content: 'Changchun Huaxiang Car Silencer Co.,Ltd. "Special Contribution" von FAW Car Co., Ltd.'

        }], [{
            poster: require('../../assets/img/about/award/1.jpg'),
            year: 'Jahr 2016',
            title: 'Excellent Supplier Award',
            content: 'NBHX Electronic Co., Ltd.: "2016 Excellent Supplier Award" von SAIC-VW'

        }, {
            poster: require('../../assets/img/about/award/2.jpg'),
            year: 'Jahr 2016',
            title: 'Quality Achievement Award',
            content: 'Changchun Huaxiang Car Muffer Co.,Ltd. "Quality Achievement Award" von Tianjin FAW Toyota Motor Co. Ltd'

        }, {
            poster: require('../../assets/img/about/award/3.jpg'),
            year: 'Jahr 2016',
            title: '"A-Lieferant" Award',
            content: 'NBHX Electronic Co., Ltd.: "A-Lieferant" Award'

        }]],
    合作共赢: 'Erfolgreiche Partnerschaft',
    contact: {
        c1: 'Addresse: 6F Block A, Oriental Financial Plaza, No.1168, Century Avenue, Shanghai, China ',
        c2: 'Postleitzahl: 200122',
        c3: 'Telefon: +86 21 68949998',
        text: 'Kontakt Details der Tochterunternehmen',
        t1: 'Wir bieten unseren Kunden qualitativ hochwertige Produkte und Dienstleistungen an. Um dieses Ziel zu erreichen, bestehen wir darauf, mit qualifizierten und effizienten Lieferanten zusammenzuarbeiten. Wir sind immer auf der Suche nach neuen Partnern, um eine qualitativ hochwertige und marktführende Position zu behaupten. Wenn Sie an einer Entwicklung mit uns interessiert sind, füllen Sie bitte den beigefügten Lieferantenfragebogen aus und senden Sie eine E-Mail an <a href="mailto:supplierinfo@nbhx.com.cn">supplierinfo@nbhx.com.cn</a>.',
        t2: 'Lieferantenbefragung'
    }
}
